import { VueQueryPlugin, type VueQueryPluginOptions } from '@tanstack/vue-query';

import { createQueryClient } from '@/wabunka/packages/core/api/queryClient';

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClient: createQueryClient(),
};

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VueQueryPlugin, vueQueryPluginOptions);
});
